var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74264 15.9969H0.5V11.7543L11.935 0.319257C12.3256 -0.0712628 12.9587 -0.0712628 13.3492 0.319257L16.1777 3.14769C16.5682 3.53821 16.5682 4.17138 16.1777 4.5619L4.74264 15.9969ZM0.5 17.9969H18.5V19.9969H0.5V17.9969Z",
    fill: "#005F73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLine2);
export default __webpack_public_path__ + "static/media/edit-line-2.a1f94987f6b2f9e43d2caa204d16e7a4.svg";
export { ForwardRef as ReactComponent };